import {
  browserLocalPersistence,
  connectAuthEmulator,
  getAuth,
  getRedirectResult,
  setPersistence,
  signInWithRedirect,
  signOut,
  getIdToken
} from 'firebase/auth'
import AzureAdAuthProvider from '../../microsoft/AzureAdAuthProvider'
import production from '../../utils/production'
import UserAccount from './UserAccount'
import { app } from '../firebaseApp'

export const auth = getAuth(app)
if (!production && process.env.PUBLIC_USE_EMU !== 'false') {
  const emulatorLocation = window.location.href.replace(':3000', ':9099')
  connectAuthEmulator(auth, emulatorLocation, { disableWarnings: true })
}
const persistenceInit = setPersistence(auth, browserLocalPersistence)

export const staffPointAd = new AzureAdAuthProvider(
  '5303131b-40b3-4f89-9b09-3a4ad7bc2275'
)

async function getFederatedUser () {
  const credentials = await getRedirectResult(auth)
  if (credentials) {
    return credentials.user
  }
}

async function getLocalUser () {
  await persistenceInit
  const user = auth.currentUser
  if (user) {
    return user
  }
}

export async function getUser () {
  // Check local storage
  let user = await getLocalUser()
  if (user) return new UserAccount(user)

  // Check federated provider's redirect result:
  // - Microsoft (StaffPoint AD)
  user = await getFederatedUser()
  if (user) return new UserAccount(user)

  // Leave in unauthenticated state
  return null
}

export async function signInWithStaffPointAd () {
  await signInWithRedirect(auth, staffPointAd)
}

export async function signOutUser () {
  await signOut(auth)
}
export async function refreshToken () {
  const user = await getLocalUser()
  await getIdToken(user, true)
}
